'use strict';
var fails = require('../internals/fails');

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/array-method-is-strict.js
// module id = 102
// module chunks = 0